module.exports = __webpack_public_path__ + "static/media/tpn-events-desktop-2.2a7897c9.jpg";